<!--
 * @message: 
 * @Author: Betway<848032671@qq.com>
 * @Github: github
 * @Date: 2020-07-09 13:15:28
 * @FilePath: /mrc_ess_web_fronted/src/components/MRC_ESS_Taber.vue
 * @最后编辑: Betway
 * @最后修改时间: 2020-08-21 15:15:47
 -->
<template>
  <v-tabs
    v-model="tab"
    :centered="centered"
    :background-color="backgroundColor"
    :grow="grow"
    class="rounded-lg"
    color="primary"
    :style="{ backgroundColor: backgroundColor }"
  >
    <template v-for="(item, n) in items">
      <v-tab :key="n + 1" :href="`#tab-${n + 1}`" class="text-capitalize">{{
        item
      }}</v-tab>
    </template>
    <v-tabs-items v-model="tab" class="rounded-lg mt-3" v-if="showTab">
      <v-tab-item
        v-for="(item, n) in items"
        :key="`${n + 1}-content`"
        :value="`tab-${n + 1}`"
      >
        <v-card class="pa-0" :elevation="0">
          <v-card-text :class="contentBackground">
            <slot :name="`content-${n + 1}`"></slot>
          </v-card-text>
        </v-card>
      </v-tab-item>
    </v-tabs-items>
  </v-tabs>
</template>
<script>
export default {
  name: "Taber",
  props: {
    centered: { default: true, type: Boolean },
    grow: { default: true, type: Boolean },
    showTab: { default: true, type: Boolean },
    curTab: { default: "tab-1", type: String, required: true },
    backgroundColor: { default: "var(--taber-nav-color)", type: String },
    items: { default: [], type: [Array, String], required: true },
    contentBackground: { default: "", type: String },
  },
  watch: {
    tab(val) {
      this.$emit("change", val);
    },
  },
  mounted() {
    this.tab = this.curTab;
  },
  data() {
    return {
      tab: "tab-1",
    };
  },
};
</script>
